export const powerBiUrl =
  "https://app.powerbi.com/view?r=eyJrIjoiN2RiMDZmZDEtNGRiNS00YThiLThlYjktMDFiZDllZmMyZGU5IiwidCI6IjRiZTJiZDU2LTA0OWMtNGY4ZS05ZjI2LTVlNWY5ZTM0YTA5NSIsImMiOjEwfQ%3D%3D";

const RouteName = {
  Ticket: "/",

  CreateTicket: "/creat-ticket",
  Login: "/login",
  Register: "/register",

  PowerBi: "/power-bi",

  External: {
    Login: "external/login",
  },
};

const Route = {
  Ticket: {
    View: RouteName.Ticket,
    Create: RouteName.CreateTicket,
  },

  External: {
    Login: RouteName.External.Login,
  },

  Auth: {
    Login: RouteName.Login,
    Register: RouteName.Register,
  },

  PowerBi: RouteName.PowerBi,
};

export default Route;
